<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="5" md="6" class="worklogstats">
        <WorkLogStats />
        <Idle />
        <VacationRequestForm margin embedded />
        <RepositoryBackupStats />
      </b-col>
      <b-col class="projectstats">
        <h3>{{ $dt('dashboard.my_projects_title', 'My Projects') }}</h3>
        <MyProjects />
        <h3>Project issue quality</h3>
        <ProjectIssueForTimeStats />
        <Absences :days="56" extendedView />
      </b-col>
      <!-- <b-col  lg="3">
      </b-col> -->
    </b-row>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import WorkLogStats from '@/views/components/dash/WorkLogStats.vue';
import ProjectIssueForTimeStats from '@/views/components/dash/ProjectIssueForTimeStats';
import Absences from '@/views/components/dash/Absences';
import Idle from '@/views/components/dash/Idle';
import VacationRequestForm from '@/views/components/vacations/VacationRequestForm';
import MyProjects from '@/views/Project/MyProjects';
import RepositoryBackupStats from './components/dash/RepositoryBackupStats.vue';

export default {
  name: 'dashboard',
  components: {
    Absences,
    Idle,
    WorkLogStats,
    ProjectIssueForTimeStats,
    MyProjects,
    VacationRequestForm,
    RepositoryBackupStats,
  },
  computed: {
    ...mapGetters('UserLogs', ['usersLastPlannedLogs']),
    // ...mapGetters('Auth', ['user', 'myProjects']),
    // ...mapGetters('JiraProjects', ['projects'])
  },
  methods: {
    ...mapActions('UserLogs', ['LOAD_GET_USERS_LAST_PLANNED_LOGS']),
    openProject(log) {
      this.$router.push({ name: 'ProjectTabPlanning', params: { id: log.project_id } });
    },
    redirectToProjectPage(projectId) {
      this.$router.push({ name: 'ProjectTabPlanning', params: { id: projectId } });
    }
  },
  mounted() {
    this.LOAD_GET_USERS_LAST_PLANNED_LOGS();
  }
};
</script>
<style scoped lang="scss">
.table td,
th {
  padding: 5px;
}

.project-name:hover {
  cursor: pointer;
  color: #ee0044;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
